import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Wrapper = styled.div`
  margin-left: 32px;
`;

const ContentSpacer = ({ children }) => <Wrapper>{children}</Wrapper>;

export default ContentSpacer;

ContentSpacer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node),
    PropTypes.node]).isRequired,
};
